import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Au-dessus du FAB « Aide » (Nimba) et de la nav mobile,
 * pour éviter tout chevauchement en bas de page.
 */
const BACK_TO_TOP_BOTTOM =
  'calc(5.75rem + 3.5rem + env(safe-area-inset-bottom, 0px))';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      style={{
        position: 'fixed',
        bottom: BACK_TO_TOP_BOTTOM,
        right: '0.85rem',
        zIndex: 1060,
        backgroundColor: 'rgba(12, 61, 114, 0.86)',
        color: 'white',
        border: '1px solid rgba(255, 255, 255, 0.28)',
        borderRadius: '50%',
        width: '44px',
        height: '44px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.18)',
        transition: 'transform 0.2s ease, background-color 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.06)';
        e.currentTarget.style.backgroundColor = 'rgba(12, 61, 114, 0.94)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.backgroundColor = 'rgba(12, 61, 114, 0.86)';
      }}
      aria-label="Retour en haut"
    >
      <ArrowUp size={20} />
    </button>
  );
};

export default BackToTopButton;
